function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t(require("prop-types"), require("react"), require("react-dom")) : "function" == typeof define && define.amd ? define(["prop-types", "react", "react-dom"], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.ReactFlexModal = t(require("prop-types"), require("react"), require("react-dom")) : e.ReactFlexModal = t(e.PropTypes, e.React, e.ReactDOM);
}(this, function (n, o, i) {
  return function (n) {
    var o = {};

    function i(e) {
      if (o[e]) return o[e].exports;
      var t = o[e] = {
        i: e,
        l: !1,
        exports: {}
      };
      return n[e].call(t.exports, t, t.exports, i), t.l = !0, t.exports;
    }

    return i.m = n, i.c = o, i.d = function (e, t, n) {
      i.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, i.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, i.t = function (t, e) {
      if (1 & e && (t = i(t)), 8 & e) return t;
      if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
      var n = Object.create(null);
      if (i.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        i.d(n, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return n;
    }, i.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return i.d(t, "a", t), t;
    }, i.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, i.p = "", i(i.s = 4);
  }([function (e, t) {
    e.exports = n;
  }, function (e, t) {
    e.exports = o;
  }, function (e, t) {
    e.exports = i;
  }, function (e, t, n) {
    var o;
    /*!
      Copyright (c) 2017 Jed Watson.
      Licensed under the MIT License (MIT), see
      http://jedwatson.github.io/classnames
    */

    /*!
      Copyright (c) 2017 Jed Watson.
      Licensed under the MIT License (MIT), see
      http://jedwatson.github.io/classnames
    */

    !function () {
      "use strict";

      var a = {}.hasOwnProperty;

      function s() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var n = arguments[t];

          if (n) {
            var o = _typeof(n);

            if ("string" == o || "number" == o) e.push(n);else if (Array.isArray(n) && n.length) {
              var i = s.apply(null, n);
              i && e.push(i);
            } else if ("object" == o) for (var r in n) {
              a.call(n, r) && n[r] && e.push(r);
            }
          }
        }

        return e.join(" ");
      }

      e.exports ? (s.default = s, e.exports = s) : void 0 === (o = function () {
        return s;
      }.apply(t, [])) || (e.exports = o);
    }();
  }, function (e, t, n) {
    "use strict";

    n.r(t);

    var o = n(1),
        m = n.n(o),
        i = n(2),
        r = n.n(i),
        a = n(0),
        s = n.n(a),
        l = "data-modal-container",
        c = function c() {
      var e = document.querySelector("[".concat(l, "]"));
      return null === e && ((e = document.createElement("div")).setAttribute(l, ""), document.body.appendChild(e)), e;
    },
        u = n(3),
        y = n.n(u),
        p = function p() {
      return "undefined" != typeof window && window.document;
    },
        f = "\n  width: 100px;\n  height: 100px;\n  position: fixed;\n  top: -9999px;\n  left: -9999px;\n  z-index: -1;\n  overflow: scroll;\n  visibility: hidden;\n".replace(/\s+/g, ""),
        d = function d() {
      if (!p()) return 0;
      var e = document.body,
          t = document.createElement("div");
      t.setAttribute("style", f), e.appendChild(t);
      var n = t.offsetWidth - t.clientWidth;
      return e.removeChild(t), n;
    };

    function h(e) {
      return (h = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      })(e);
    }

    function v(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }

    function b(e) {
      return (b = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function g(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function w(e, t) {
      return (w = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function T(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var C = 27,
        O = "Modal",
        x = O + "-open",
        _ = function (e) {
      function n(e) {
        var t;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, n), T(g(t = function (e, t) {
          return !t || "object" !== h(t) && "function" != typeof t ? g(e) : t;
        }(this, b(n).call(this, e))), "state", {
          enter: !1,
          enterActive: !1,
          leave: !1,
          leaveActive: !1
        }), T(g(t), "onCloseClick", function () {
          t.close();
        }), T(g(t), "onInsideDialogClick", function (e) {
          t.willClose = !1;
        }), T(g(t), "onKeyDown", function (e) {
          e.keyCode === C && t.props.isOpen && t.close();
        }), T(g(t), "onOutsideDialogClick", function (e) {
          t.willClose && t.close(), t.willClose = !0;
        }), t.willClose = !0, t.scrollTop = 0, t.doc = document.documentElement, t;
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && w(e, t);
      }(n, o["Component"]), function (e, t, n) {
        t && v(e.prototype, t), n && v(e, n);
      }(n, [{
        key: "componentDidMount",
        value: function value() {
          var e = this;
          this.storedActiveElement = document.activeElement, this.scrollTop = window.pageYOffset || this.doc.scrollTop, setTimeout(function () {
            e.enforceFocus();
          }, 0), this.props.transition && (this.transitionTimeStart = new Date(), this.setState({
            enter: !0
          }, function () {
            e.setState({
              enterActive: !0
            }), e.enterTimer = setTimeout(function () {
              e.setState({
                enter: !1,
                enterActive: !1
              });
            }, e.props.transitionEnterTimeout);
          })), this.addRootClass(), "fixed" == this.props.position && (document.body.style.paddingRight = "".concat(d(), "px"), this.doc.style.position = "fixed", this.doc.style.width = "100%", this.doc.style.top = -this.scrollTop + "px", this.doc.style.overflow = "hidden");
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e, t) {
          document.activeElement === this.modal || this.modal.contains(document.activeElement) || this.enforceFocus();
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.enterTimer && clearTimeout(this.enterTimer), this.leaveTimer && clearTimeout(this.leaveTimer), this.storedActiveElement.focus(), this.storedActiveElement = null, this.removeRootClass(), "fixed" == this.props.position && (document.body.style.paddingRight = "", this.doc.style.position = "", this.doc.style.width = "", this.doc.style.top = "", this.doc.style.overflow = "", window.scrollTo(0, this.scrollTop));
        }
      }, {
        key: "getScrollbarSize",
        value: function value() {
          var e = document.createElement("div");
          return e.style.width = "100px", e.style.overflow = "scroll", document.body.appendChild(e), e.offsetWidth - e.clientWidth;
        }
      }, {
        key: "getTransitionLeaveTimeout",
        value: function value() {
          return Math.min(this.transitionTimeEnd - this.transitionTimeStart, this.props.transitionLeaveTimeout);
        }
      }, {
        key: "addRootClass",
        value: function value() {
          document.documentElement.classList.add(x);
        }
      }, {
        key: "close",
        value: function value() {
          var e = this;
          this.props.transition ? (this.enterTimer && clearTimeout(this.enterTimer), this.state.leave || this.setState({
            leave: !0
          }, function () {
            e.setState({
              leaveActive: !0
            }), e.transitionTimeEnd = new Date(), e.leaveTimer = setTimeout(function () {
              e.setState({
                leave: !1,
                leaveActive: !1
              }), e.props.onClose();
            }, e.getTransitionLeaveTimeout());
          })) : this.props.onClose();
        }
      }, {
        key: "enforceFocus",
        value: function value() {
          this.modal.focus();
        }
      }, {
        key: "removeRootClass",
        value: function value() {
          document.documentElement.classList.remove(x);
        }
      }, {
        key: "render",
        value: function value() {
          var e,
              t,
              n = this,
              o = this.props,
              i = o.children,
              r = o.isOpen,
              a = o.modalClass,
              s = o.modalDialogClass,
              l = this.state,
              c = l.enter,
              u = l.enterActive,
              p = l.leave,
              f = l.leaveActive,
              d = y()((T(e = {}, O, !0), T(e, a, a), T(e, "Modal--open", r), T(e, "Modal--enter", c), T(e, "Modal--enter-active", u), T(e, "Modal--leave", p), T(e, "Modal--leave-active", f), e));
          return m.a.createElement("div", {
            ref: function ref(e) {
              n.modal = e;
            },
            className: d,
            tabIndex: -1,
            onKeyDown: this.onKeyDown,
            onClick: this.onOutsideDialogClick
          }, m.a.createElement("div", {
            className: "".concat(O, "__layout")
          }, m.a.createElement("div", {
            className: y()((t = {}, T(t, "".concat(O, "__dialog"), !0), T(t, s, s), t)),
            onClick: this.onInsideDialogClick
          }, m.a.createElement("button", {
            className: "".concat(O, "__close"),
            onClick: this.onCloseClick
          }, m.a.createElement("span", {
            className: "".concat(O, "__close-icon")
          }), m.a.createElement("span", {
            className: "".concat(O, "__close-text")
          }, "Close")), m.a.createElement("div", {
            className: "".concat(O, "__content")
          }, i))));
        }
      }]), n;
    }();

    T(_, "propTypes", {
      children: s.a.node,
      isOpen: s.a.bool,
      position: s.a.string,
      modalClass: s.a.string,
      modalDialogClass: s.a.string,
      transition: s.a.bool,
      transitionEnterTimeout: s.a.number,
      transitionLeaveTimeout: s.a.number,
      onClose: s.a.func
    }), T(_, "defaultProps", {
      isOpen: !1,
      position: "fixed",
      transition: !1,
      transitionEnterTimeout: 300,
      transitionLeaveTimeout: 300
    });
    var E = _;

    function j(e) {
      return (j = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      })(e);
    }

    function k(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
      }
    }

    function S(e, t) {
      return !t || "object" !== j(t) && "function" != typeof t ? function (e) {
        if (void 0 !== e) return e;
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }(e) : t;
    }

    function P(e) {
      return (P = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function D(e, t) {
      return (D = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function A(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    n.d(t, "default", function () {
      return M;
    });

    var M = function (e) {
      function t() {
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), S(this, P(t).apply(this, arguments));
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && D(e, t);
      }(t, o["Component"]), function (e, t, n) {
        t && k(e.prototype, t), n && k(e, n);
      }(t, [{
        key: "componentDidMount",
        value: function value() {
          this.portalContainer = c(), this.props.isOpen && this.mountPortal(this.props);
        }
      }, {
        key: "componentDidUpdate",
        value: function value() {
          this.props.isOpen ? this.mountPortal(this.props) : this.unmountPortal();
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.unmountPortal();
        }
      }, {
        key: "mountPortal",
        value: function value(e) {
          this.container || (this.container = document.createElement("div"), this.portalContainer.appendChild(this.container)), r.a.render(m.a.createElement(E, e), this.container);
        }
      }, {
        key: "unmountPortal",
        value: function value() {
          this.container && r.a.unmountComponentAtNode(this.container);
        }
      }, {
        key: "render",
        value: function value() {
          return null;
        }
      }]), t;
    }();

    A(M, "propTypes", {
      children: s.a.node,
      isOpen: s.a.bool,
      position: s.a.string,
      modalClass: s.a.string,
      modalDialogClass: s.a.string,
      transition: s.a.bool,
      transitionEnterTimeout: s.a.number,
      transitionLeaveTimeout: s.a.number,
      onClose: s.a.func
    }), A(M, "defaultProps", {
      isOpen: !1
    });
  }]);
});